<template>
  <div class="main">
    <report-top
      ><ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div id="formTable">
        <div class="formTableItem">
          <p class="label">时间范围</p>
          <start-end ref="startEnd" timeModel="2,3,0"></start-end>
        </div>
        <div class="formTableItem">
          <p class="label">选择车辆</p>
          <selecAlotCCar
            ref="selecAlotCCar"
            @deviceIdList="searchItem.deviceIdList = $event"
          ></selecAlotCCar>
        </div>
        <div class="formTableItem">
          <Button @click="chaxun" type="primary" class="chaxun">查询</Button>
        </div>
      </div>
    </div>
    <Row style="width: 100%">
      <Col span="8"
        ><div style="width: 100%; height: 400px">
          <pie :percent="percent"></pie>
        </div>
        <h3 style="text-align: center">报警占比</h3></Col
      >
      <Col span="16"
        ><div style="width: 100%; height: 400px">
          <myLine :countTrendData="countTrendData"></myLine>
        </div>
        <h3 style="text-align: center">报警数据趋势</h3></Col
      >
    </Row>
  </div>
</template>
<script>
import pie from "./pie.vue";
import myLine from "./line.vue";

export default {
  components: { pie, myLine },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "单位名称",
          key: "groupName",
        },
        {
          title: "驾驶员",
          key: "driverName",
        },
        {
          title: "停留里程",
          key: "stayMileage",
        },
        {
          title: "停留地点",
          slot: "stayAdd",
        },
        {
          title: "开始时间",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime));
          },
        },
        {
          title: "结束时间",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime));
          },
        },
      ],
      countTrendData: [],
      percent: [],
      total: 0,
      searchItem: {
        keyword: "",
        endTime: 0,
        startTime: 0,
        type: 3, //1-报警类型，2-报警级别，3-事件类型
        deviceIdList: [],
        order: 0, //0-正序，1-倒叙
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/assay/alarmAscRatio",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data;
          this.percent = data;
        }
      });
    },
    countTrend() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/assay/alarmAscTrend",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;
          // console.log("countTrendcountTrend", res);
          for (let i = 0; i < data.dateList.length; i++) {
            data.dateList[i] = this.utils.time(data.dateList[i], "mmdd");
          }
          // for (const i in data.dateList) {
          //   data.dateList[i]=this.utils.time(data.dateList[i],'mmdd');
          // }
          this.countTrendData = data;
        }
      });
    },
    search() {
      this.getList();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
      this.countTrend();
    },
    openMap(v) {
      var obj = {
        address: v.stayAdd,
        lng: v.stayX,
        lat: v.stayY,
      };
      this.$refs.lymap.open(obj);
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// ../common/src/components/alarm/ascAnalyse.vue